import en from './en.json'
import it from './it.json'

export const clientTranslations = {
	en,
	it
} as const
